import { AnyAction } from 'redux';
import { TENANT_ACTIONS } from '../actions/index';
import { TenantSegmentsState } from '../types/state';
import { addMonths, endOfMonth, startOfMonth } from 'date-fns';
import produce from 'immer';

const initialState: TenantSegmentsState = {
  selectedDateRange: [
    startOfMonth(new Date()),
    endOfMonth(addMonths(new Date(), 2)),
  ],
  isLoading: false,
  areaSegment: undefined,
  selectedGroup: {},
  factors: undefined,
  keyMetric: undefined,
  selectedSegment: undefined,
  tenantGroups: undefined,
};

const tenantSegmentsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case TENANT_ACTIONS.TNT_LOADING: {
      return produce(state, (dft) => {
        dft.isLoading = action.payload;
      });
    }
    case TENANT_ACTIONS.SET_TNT_DATERANGE: {
      return produce(state, (dft) => {
        dft.selectedDateRange = [...action.payload];
      });
    }
    case TENANT_ACTIONS.SET_SELECTED_SEGMENT: {
      return produce(state, (dft) => {
        dft.selectedSegment = action.payload;
      });
    }
    case TENANT_ACTIONS.SET_SELECTED_GROUP: {
      return produce(state, (dft) => {
        dft.selectedGroup = action.payload;
      });
    }
    case TENANT_ACTIONS.GET_AREA_SEGMENTS: {
      return produce(state, (dft) => {
        dft.areaSegment = action.payload;
      });
    }
    case TENANT_ACTIONS.GET_GROUPED_TENANTS: {
      return produce(state, (dft) => {
        dft.tenantGroups = action.payload;
      });
    }
    case TENANT_ACTIONS.GET_SEGMENT_FACTORS: {
      return produce(state, (dft) => {
        dft.factors = action.payload;
      });
    }
    case TENANT_ACTIONS.GET_KEY_METRICS: {
      return produce(state, (dft) => {
        dft.keyMetric = action.payload;
      });
    }
    default:
      return state;
  }
};

export default tenantSegmentsReducer;
